// src/App.jsx
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import LoginPage from "./components/LoginPage";
import Dashboard from "./components/Dashboard";
import Home from "./components/Home";
import Users from "./components/Users";
import CategoryManager from "./components/CategoryManager";
import CompanyRegistration from "./components/CompanyRegistration";
import ProductTable from "./components/ProductTable";
import ProductEditPage from "./components/ProductEditPage";
import AddProductForm from "./components/AddProductForm";
import RequestPage from "./components/RequestPage";
import FabricForm from "./components/Fabrics";
import FabricColorPage from "./components/FabricColorPage";
import ColorManager from "./components/ColorManager";
import SizeManager from "./components/SizeManager";
import Orders from "./components/Orders";
import OrderSignedDeliveryNote from "./components/OrderSignedDeliveryNote";
import ProductionOrders from "./components/ProductionOrders";
import Profile from "./components/Profile";
import ProductVariations from "./components/ProductVariations";
import VariationDetailsPage from "./components/VariationDetailsPage";
import ContactUs from "./components/ContactUs";
import News from "./components/News";
import AddEmployee from "./components/AddEmployee";
import AddNewBed from "./components/AddNewBed";
import StoragePriceConfig from "./components/StoragePriceConfig";
import DeliveriesOperation from "./components/DeliveriesOperation";
import ProductionDashboard from "./components/ProductionDashboard";
import AnnouncementsAdmin from "./components/AnnouncementsAdmin";
import FaqManager from "./components/FaqManager";
import UrgentOrders from "./components/UrgentOrders";
import StockistsAdminPage from "./components/StockistsAdminPage";
// ✅ Invoices
import Invoices from "./components/Invoices";
import InvoiceManager from "./components/InvoiceManager";
import DownloadsAdmin from "./components/DownloadsAdmin";
import UpcomingProductsAdmin from "./components/UpcomingProductsAdmin";
import AdminComplaints from "./components/AdminComplaints";
// ✅ NEW: Manage Order Sheets page (correct file name)
import ManageOrderSheets from "./components/ManageOrderSheets";

// Context Providers
import { ProductProvider } from "./contexts/ProductContext";
import { OrderProvider } from "./contexts/OrderContext";
import { UserProvider } from "./contexts/UserContext";
import { StatsProvider } from "./contexts/statsContext";

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem("isAuthenticated") === "true";
  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

const App = () => {
  return (
    <Router>
      <Routes>
        {/* Public */}
        <Route path="/login" element={<LoginPage />} />

        {/* Protected */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <UserProvider>
                <ProductProvider>
                  <OrderProvider>
                    <StatsProvider>
                      <Dashboard />
                    </StatsProvider>
                  </OrderProvider>
                </ProductProvider>
              </UserProvider>
            </ProtectedRoute>
          }
        >
          {/* Default landing */}
          <Route index element={<Home />} />
          <Route path="home" element={<Home />} />

          {/* Products */}
          <Route path="products" element={<ProductTable />} />
          <Route path="add-product" element={<AddProductForm />} />
          <Route path="add-new-bed" element={<AddNewBed />} />
          <Route path="storage-prices" element={<StoragePriceConfig />} />

          {/* Catalog settings */}
          <Route path="categories" element={<CategoryManager />} />
          <Route path="colors" element={<ColorManager />} />
          <Route path="sizes" element={<SizeManager />} />

          {/* Fabrics */}
          <Route path="fabrics" element={<FabricForm />} />
          <Route path="fabric-colors/:fabricName" element={<FabricColorPage />} />

          {/* Users & Requests */}
          <Route path="users" element={<Users />} />
          <Route path="new-user-registration" element={<CompanyRegistration />} />
          <Route path="requests" element={<RequestPage />} />
          <Route path="add-new-employees" element={<AddEmployee />} />

          {/* Orders & Production */}
          <Route path="all-orders" element={<Orders />} />
          <Route path="order-signed-delivery-note" element={<OrderSignedDeliveryNote />} />
          <Route path="production-dashboard" element={<ProductionDashboard />} />
          <Route path="production-orders" element={<ProductionOrders />} />
          <Route path="deliveries-operation" element={<DeliveriesOperation />} />

          {/* ✅ NEW: Manage Order Sheets route */}
          <Route path="order-sheets" element={<ManageOrderSheets />} />

          {/* Edit / Details */}
          <Route path="edit-product/:id" element={<ProductEditPage />} />
          <Route path="product/:id" element={<ProductEditPage />} />

          {/* Variations */}
          <Route path="variations" element={<ProductVariations />} />
          <Route path="product-variations/:productId" element={<VariationDetailsPage />} />

          {/* Profile & Extras */}
          <Route path="profile" element={<Profile />} />
          <Route path="contact-us" element={<ContactUs />} />
          <Route path="news" element={<News />} />
          <Route path="announcements-admin" element={<AnnouncementsAdmin />} />
          <Route path="faqs" element={<FaqManager />} />


          {/* Invoices */}
          <Route path="invoices" element={<Invoices />} />
          <Route path="invoices/manage" element={<InvoiceManager />} />
          <Route path="invoices/:invoiceId" element={<InvoiceManager />} />

          <Route path="/urgent-orders" element={<UrgentOrders />} />
          <Route path="stockists-admin" element={<StockistsAdminPage />} />
          <Route path="/downloads-admin" element={<DownloadsAdmin />} />
          <Route path="upcoming-products-admin" element={<UpcomingProductsAdmin />} />
          <Route path="complaints-admin" element={<AdminComplaints />} />
          
        </Route>
      </Routes>
    </Router>
  );
};

export default App;
